export default "__VITE_ASSET__DnNuqmbt__"